// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select-module--wrapper--1r5d5","attributeOptionSelect":"Select-module--attribute-option--select--22pSF"};